import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  style: {"enable-background":"new 0 0 512 512"},
  "xml:space": "preserve"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      style: {"fill":"#EE7023"},
      d: "M413.7,113.1c0-8.3-6.7-15-15-15H113.3c-8.3,0-15,6.7-15,15c0,99.9,71.1,179.4,138.9,210.8v55.7\n\tc0,20.7-25.2,37.5-56.3,37.5V436h150.2v-18.8c-31.1,0-56.3-16.8-56.3-37.5l0-55.7C342.6,292.5,413.7,213,413.7,113.1z M129,128.1\n\th33.4l14.7,111.8C152,210.3,132.6,172.3,129,128.1z M289.6,248.3h-59.6v-14.3l20.4-0.8v-67.4l-20.4,6.3v-14.7l25.6-8.6h13.6v84.5\n\tl20.4,0.8V248.3z M349.7,128.1H383c-3.6,44.2-23,82.2-48.1,111.8L349.7,128.1z"
    }, null, -1)
  ]))]))
}
export default { render: render }